import React from 'react';
import { useTranslation } from '../contexts/LanguageContext';

const LanguageSwitcher = ({ className = '' }) => {
  const { language, setLanguage, t } = useTranslation();

  return (
    <div
      className={`language-switcher ${className}`.trim()}
      role="group"
      aria-label={t('common.language')}
    >
      {['hr', 'en'].map((code) => (
        <button
          key={code}
          type="button"
          className={language === code ? 'is-active' : ''}
          onClick={() => setLanguage(code)}
          aria-pressed={language === code}
        >
          {code.toUpperCase()}
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
